var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import Gradient from '../abstract/Gradient';
import * as lodash from '../utils/lodash';
var defaultOption = {
    cx: 0.5,
    cy: 0.5,
    r: 1,
    stops: [],
};
var RadialGradient = /** @class */ (function (_super) {
    __extends(RadialGradient, _super);
    function RadialGradient(option) {
        var _this = _super.call(this, __assign(__assign({}, defaultOption), option)) || this;
        _this.type = 'radialGradient';
        return _this;
    }
    RadialGradient.prototype.clone = function () {
        return new RadialGradient(lodash.cloneDeep(this.option));
    };
    RadialGradient.prototype.getCanvasContextStyle = function (ctx, rect) {
        var option = this.option;
        var min = Math.min(rect.width, rect.height);
        var x1 = option.global ? option.cx : option.cx * rect.width + rect.x;
        var y1 = option.global ? option.cy : option.cy * rect.height + rect.y;
        var r1 = option.global ? option.r : min * option.r;
        var x2 = x1;
        var y2 = y1;
        var gradient = ctx.createRadialGradient
            ? ctx.createRadialGradient(x1, y1, 0, x2, y2, r1)
            : ctx.createCircularGradient(x1, y1, r1);
        option.stops.forEach(function (stop) {
            gradient.addColorStop(stop.offset, stop.color);
        });
        return gradient;
    };
    RadialGradient.prototype.getSVGNode = function () {
        var _a = this.option, cx = _a.cx, cy = _a.cy, r = _a.r, stops = _a.stops, global = _a.global;
        return {
            svgTagName: 'radialGradient',
            svgAttr: {
                gradientUnits: global ? 'userSpaceOnUse' : 'objectBoundingBox',
                id: this.id,
                cx: cx,
                cy: cy,
                r: r,
            },
            childNodes: stops.map(function (stop) {
                return {
                    svgTagName: 'stop',
                    svgAttr: {
                        offset: stop.offset * 100 + '%',
                        'stop-color': stop.color,
                    },
                };
            }),
        };
    };
    RadialGradient.prototype.toString = function () {
        var _a = this.option, cx = _a.cx, cy = _a.cy, stops = _a.stops;
        var stopStr = stops
            .map(function (stop) {
            return stop.color + " " + stop.offset * 100 + "%";
        })
            .join(', ');
        return "radial-gradient(circle at " + cx * 100 + "% " + cy * 100 + "%,  " + stopStr + ")";
    };
    return RadialGradient;
}(Gradient));
export default RadialGradient;
